module.exports = __webpack_public_path__ + "img/office-follow.d83ca60d.jpg";